// SimplifiedDashboard.jsx - A more compact dashboard alternative
import React from 'react';
import { Card, Row, Col, Tabs } from 'antd';
import { 
  CountDev, 
  CountDes, 
  CountCert, 
  CountBlog,
  RecentActivity,
  QuickStats,
  TaskReminder,
  SkillsOverview,
  WelcomeCard
} from '../components';
import { useSelector } from 'react-redux';
import {
  DashboardOutlined,
  BarChartOutlined,
  BellOutlined,
  StarOutlined
} from '@ant-design/icons';



const ROLES = {
  User: 'user',
  Admin: 'admin',
  Visitor: 'visitor',
};

const SimplifiedDashboard = () => {
  const user = useSelector((state) => state.auth.user);

  const tabItems = [
    {
      key: 'overview',
      label: (
        <span className="flex items-center space-x-2">
          <DashboardOutlined />
          <span>Overview</span>
        </span>
      ),
      children: (
        <div className="space-y-6">
          {/* Stats Cards */}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} lg={6}>
              <CountDev />
            </Col>
            {(user?.role === ROLES.Admin || user?.role === ROLES.Visitor) && (
              <Col xs={24} sm={12} lg={6}>
                <CountDes />
              </Col>
            )}
            <Col xs={24} sm={12} lg={6}>
              <CountCert />
            </Col>
            <Col xs={24} sm={12} lg={6}>
              <CountBlog />
            </Col>
          </Row>

          {/* Quick Stats and Recent Activity */}
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <QuickStats />
            </Col>
            <Col xs={24} lg={12}>
              <RecentActivity />
            </Col>
          </Row>
        </div>
      ),
    },
    {
      key: 'analytics',
      label: (
        <span className="flex items-center space-x-2">
          <BarChartOutlined />
          <span>Analytics</span>
        </span>
      ),
      children: (
        <div className="space-y-6">
          <QuickStats />
          <SkillsOverview />
        </div>
      ),
    },
    {
      key: 'tasks',
      label: (
        <span className="flex items-center space-x-2">
          <BellOutlined />
          <span>Tasks</span>
        </span>
      ),
      children: (
        <div className="space-y-6">
          <TaskReminder />
          <RecentActivity />
        </div>
      ),
    },
    {
      key: 'skills',
      label: (
        <span className="flex items-center space-x-2">
          <StarOutlined />
          <span>Skills</span>
        </span>
      ),
      children: (
        <div className="space-y-6">
          <SkillsOverview />
        </div>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-bg-primary p-6">
      <div className="max-w-7xl mx-auto">
        {/* Welcome Section */}
        <div className="mb-8">
          <WelcomeCard user={user} />
        </div>

        {/* Tabbed Dashboard Content */}
        <Card className="shadow-medium border border-border-light rounded-xl">
          <Tabs
            defaultActiveKey="overview"
            items={tabItems}
            size="large"
            className="tabs"
          />
        </Card>

        
      </div>
    </div>
  );
};

export default SimplifiedDashboard;